import {createAsyncThunk} from '@reduxjs/toolkit'

import {MobileAppType} from '@web/core/constants'
import {ROUTER_ORDER_SALE_HISTORY, ROUTER_ORDER_SALE_SETTLEMENT} from '@web/core/routes'
import {TIMELINE_MOBILE_URL, TIMELINE_URL} from '@web/core/urls'
import {goBack, isPopupWindow} from '@web/helpers/browser'
import {getOriginPathname} from '@web/helpers/path'
import {isMobile, isPayApp, mobileAppType} from '@web/helpers/userAgent'

import {ThunkApi} from '../interfaces'

const closeAppScheme: Record<MobileAppType, string> = {
    /** 네이버 치지직 */
    CHZZK: '',
    /** 네이버 앱 */
    NAVER: '',
    /** 네이버 카페앱 */
    NAVER_CAFE: '',
    /** 네이버 지도앱 */
    NAVER_MAP: '',
    /** 네이버 페이앱 */
    NAVER_PAY: 'naverapp://closewindow',
    /** 네이버 쇼핑앱 */
    NAVER_SHOPPING: '',
    /** 네이버 웹툰앱 */
    NAVER_WEBTOON: '',
    /** 네이버 시리즈앱 */
    SERIES: '',
    /** 네이버 바이브앱 */
    VIBE: '',
    /** 식별할 수 없는 앱 */
    UNKNOWN: '',
}

type FallbackType = 'TIME_LINE' | 'SALE_HISTORY' | 'SALE_SETTLEMENT'

const navigateToBack = createAsyncThunk<
    void,
    | {
          fallbackType?: 'TIME_LINE' | 'SALE_HISTORY' | 'SALE_SETTLEMENT'
          fallbackUrl?: string
          shouldPopupClose?: boolean
      }
    | undefined,
    ThunkApi
>('navigateTo/back', async (args = {}) => {
    const {fallbackType, fallbackUrl, shouldPopupClose} = args
    let isHistoryChanged = false

    const checkHistory = () => {
        isHistoryChanged = true
    }
    window.addEventListener('popstate', checkHistory)

    const UrlMap: Record<FallbackType, Maybe<string>> = {
        TIME_LINE: null,
        SALE_HISTORY: ROUTER_ORDER_SALE_HISTORY.MAIN.getHref(),
        SALE_SETTLEMENT: ROUTER_ORDER_SALE_SETTLEMENT.MAIN.getHref(),
    }

    // 공통 정책이 마련되면 이관 필요
    if (shouldPopupClose && (isPayApp || isPopupWindow())) {
        if (closeAppScheme[mobileAppType]) {
            window.location.href = closeAppScheme[mobileAppType]
        } else {
            window.self.close()
        }
    }

    goBack()

    setTimeout(() => {
        // goBack()이 동작하지 않았다면 fallback 로직 수행
        if (!isHistoryChanged) {
            const url = (() => {
                if (fallbackType && UrlMap[fallbackType]) {
                    return UrlMap[fallbackType]
                } else if (fallbackType) {
                    return isMobile ? TIMELINE_MOBILE_URL : TIMELINE_URL
                } else if (fallbackUrl) {
                    return fallbackUrl
                }
                return null
            })()

            if (!url) {
                return
            }

            if (
                // fallbackUrl로부터 새창으로 열린 케이스
                getOriginPathname(window.document.referrer) === getOriginPathname(url)
            ) {
                window.self.close()
            }
            if (getOriginPathname(window.location.href) !== getOriginPathname(url)) {
                window.location.href = url
            }
        }

        window.removeEventListener('popstate', checkHistory)
    }, 500)
})

export default navigateToBack
